import React, {useEffect, useRef} from 'react';
import {clearRequiredFieldError, resetRequiredFieldError} from "../../utils/project-utils.js";
import {useRequiredFieldError} from "../../hooks/use-required-field-error.js";

const InputTextarea = ({id, label, className, height, value, onChange, textAreaClass, labelClass, disabled = false, readOnly = false, inputRef = null, required = false, invalid = false}) => {
    const textareaRef = useRef(null);
    const isRequired = required || (typeof label === "string" && label.trim().endsWith("*"));
    const labelText = typeof label === "string" ? label.replace(/\s*\*\s*$/, "") : label;
    const requiredFieldInvalid = useRequiredFieldError(textareaRef, isRequired);
    const hasRequiredError = !disabled && !value?.trim() && (invalid || requiredFieldInvalid);

    useEffect(() => {
        if (isRequired && value?.trim()) clearRequiredFieldError(textareaRef.current);
    }, [value]);

    useEffect(() => {
        if (disabled) resetRequiredFieldError(textareaRef.current);
    }, [disabled]);

    const setTextareaRef = (element) => {
        textareaRef.current = element;

        if (typeof inputRef === "function") inputRef(element);
        else if (inputRef) inputRef.current = element;
    };

    return (
        <div className={"relative " + className}>
            <textarea id={id} ref={setTextareaRef} placeholder="" value={value} onChange={onChange} disabled={disabled} required={isRequired} data-required-field={isRequired || undefined} aria-invalid={hasRequiredError}
                style={{minHeight: height}}
                className={`block w-full px-2.5 pb-2 pt-2 text-sm bg-transparent border-[1px] rounded-md
                     border-[#e5e7eb] appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer transition-[border-color,border-width] duration-150 ease-out ${textAreaClass ?? "" } ${hasRequiredError ? "!border-[2px] !border-[#dc2626] focus:!border-[#dc2626]" : ""}`}/>
            <label htmlFor={id}
                   className={"cursor-text absolute text-sm px-1 text-gray-500 duration-300 transform " +
                       "-translate-y-4 scale-75 top-[5px] z-10 origin-[0]  peer-placeholder-shown:-top-[2px] " +
                       "peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-2 peer-focus:scale-75 " +
                       "peer-focus:-translate-y-4 left-2.5 peer-focus:top-[5px] " +
                       "peer-focus:px-1 max-w-full truncate " +
                       (disabled || readOnly ? "peer-placeholder-shown:bg-[#e9ecef] bg-disabled " : "bg-[linear-gradient(to_bottom,transparent_50%,#FFF_50%)] ") +
                       labelClass
                   }
            >
                {labelText}{isRequired ? <span className="ml-0.5">*</span> : null}
            </label>
        </div>
    );
};

export default InputTextarea;